export default defineNuxtRouteMiddleware((to, from) => {
  if (!to.path.endsWith('/') && !from.path.endsWith(to.path + '/') && !(to.path === from.path)) {
    return navigateTo(to.path + '/');
  }
})
